
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/talent-management-strategy-examples",
      function () {
        return require("private-next-pages/us/talent-management-strategy-examples/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/talent-management-strategy-examples"])
      });
    }
  